import React, { useState, useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./FilterMenu.css";

export default function FilterMenu({
  categories = [],
  brands = [],
  activeFilters = {},
  onFilterChange
}) {
  const [openCategory, setOpenCategory] = useState(null);

  /** Auto-expand category based on active filters */
  useEffect(() => {
    if (activeFilters.category) {
      setOpenCategory(activeFilters.category);
    }
  }, [activeFilters.category]);

  const toggleCategoryActive = (cat) => {
    onFilterChange("category", cat.slug);
    onFilterChange("subcategory", "");
  };

  const toggleSubcategory = (sub) => {
    onFilterChange("category", "");
    onFilterChange("subcategory", sub.slug);
  };

  const toggleBrand = (brand) => {
    onFilterChange("brand", brand.slug);
  };

  return (
    <div className="filter-menu">

      {/* Categories */}
      <div className="filter-section">
        <h4 className="section-title">Categories</h4>
        <ul className="filter-list">

          {categories.map((cat) => {
            const hasSubs = cat.subcategories?.length > 0;
            const isOpen = openCategory === cat.slug;
            const isActive = activeFilters.category === cat.slug;

            return (
              <li key={cat.slug} className="category-item">
                <div className="category-header">
                  <span
                    className={isActive ? "active" : ""}
                    onClick={() => toggleCategoryActive(cat)}
                  >
                    {cat.name}
                  </span>

                  {hasSubs && (
                    <ExpandMoreIcon
                      className={`expand-icon ${isOpen ? "rotated" : ""}`}
                      onClick={() =>
                        setOpenCategory(isOpen ? null : cat.slug)
                      }
                    />
                  )}
                </div>

                {hasSubs && isOpen && (
                  <ul className="subcategory-list">
                    {cat.subcategories.map((sub) => (
                      <li
                        key={sub.slug}
                        className={`subcategory-item ${
                          activeFilters.subcategory === sub.slug
                            ? "active"
                            : ""
                        }`}
                        onClick={() => toggleSubcategory(sub)}
                      >
                        {sub.name}
                      </li>
                    ))}
                  </ul>
                )}

              </li>
            );
          })}

        </ul>
      </div>

      {/* Brands */}
      <div className="filter-section">
        <h4 className="section-title">Brands</h4>

        <ul className="filter-list">
          {brands.slice(0, 5).map((brand) => (
            <li key={brand.slug}>
              <input
                type="checkbox"
                checked={activeFilters.brand?.includes(brand.slug)}
                onChange={() => toggleBrand(brand)}
              />
              <label>{brand.name}</label>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
